import { RequestDetailService } from "./detail.service";
import { StepperTemplate, Index, State } from "../../../../shared/stepper/stepper-template";
import { RequestStatus, ApprovalStatus } from "../../workflow.service";

export class DetailStepperTemplate extends StepperTemplate {
    private request: any;
    private requestStatus;
    private history: any[];


    constructor(
        private readonly detailService: RequestDetailService,
    ) {
        super();
        this.detailService.requestDetail
            .subscribe(x => {
                this.request = x;
                this.update()
            });
    }


    /**
     * 
     */
    private update() {
        if (this.request) {
            this.detailService.history
                .subscribe(history => {
                    if (!history || this.steps.length < 1) return;
                    this.history = history;
                    this.requestStatus = this.request ? this.request.RequestStatus : null;

                    this.clearSteps();
                    const _approvedIdx = this.getApprovalIndex();

                    for (let index = 0; index <= _approvedIdx; index++) {
                        this.steps[index].state = State.Accepted;
                    }

                    if (_approvedIdx !== Index.Default && _approvedIdx < Index.Complete
                        && this.requestStatus !== RequestStatus.REWORK_REQUESTED
                        && this.requestStatus !== ApprovalStatus.CANCELLED
                        && this.requestStatus !== ApprovalStatus.ONHOLD) {
                        this.steps[_approvedIdx + 1].state = State.Awaiting;
                    }
                });
        }
    }


    /**
     * 
     */
    private getApprovalIndex(): Index {
        return (this.ApprovalStatusTypes[this.requestStatus] || this.ApprovalStatusTypes['default'])();
    }


    /**
     * 
     */
    private readonly handleRework = (): Index => {
        this.steps[Index.New].state = State.Rework;
        this.requestStatus === RequestStatus.REWORK_REQUESTED
            ? this.steps[Index.New].description = RequestStatus.REWORK_REQUESTED
            : this.steps[Index.New].description = RequestStatus.REWORK_IN_PROGRESS;
        return Index.Default;
    }


    /**
     * 
     */
    private readonly handleInactive = (): Index => {
        let _approvedIdx;
        const actionBeforeCancelledObj = this.history.find(x => x.Action.includes(RequestStatus.COMPLETE));

        if (actionBeforeCancelledObj && actionBeforeCancelledObj.Action.includes('Part')) {
            _approvedIdx = Index.Part;
        } else if (actionBeforeCancelledObj && actionBeforeCancelledObj.Action.includes('Location')) {
            _approvedIdx = Index.Location;
        } else { //canclled at initial
            _approvedIdx = Index.New;
        }

        if (_approvedIdx < Index.Work) {
            if (this.requestStatus === ApprovalStatus.CANCELLED) {
                this.steps[_approvedIdx + 1].state = State.Cancelled;
            }
            else if (this.requestStatus === ApprovalStatus.ONHOLD) {
                this.steps[_approvedIdx + 1].state = State.OnHold;
            }
            this.steps[_approvedIdx + 1].description = ApprovalStatus.ONHOLD;
        }
        return _approvedIdx;
    }


    /**
     * 
     */
    private readonly handleApprovedWip = (): Index => {
        this.steps[Index.Location + 1].description = ApprovalStatus.APPROVED_WIP;
        return Index.Location;
    }


    /**
     * 
     */
    private readonly handleApprovedDesignerRejected = (): Index => {
        this.steps[Index.Location + 1].description = ApprovalStatus.APPROVED_DES_REJECT;
        return Index.Location;
    }


    /**
     * 
     */
    private readonly ApprovalStatusTypes = {
        'Awaiting Review': () => Index.New,
        'Initial': () => Index.New,
        'Awaiting Approval': () => Index.Part,
        'Approved': () => Index.Location,
        'Approved - WIP': this.handleApprovedWip,
        'Approved - Design Rejected': this.handleApprovedDesignerRejected,
        'Complete': () => Index.Complete,
        'Rework Requested': this.handleRework,
        'Rework In Progress': this.handleRework,
        'Cancelled': this.handleInactive,
        'OnHold': this.handleInactive,
        'default': () => Index.Default
    }

}
